import { GiftIcon } from '../../../assets/icons/GiftIcon';

export type OfferPanelProps = {
  discountPercentage?: number;
  discountTerm?: number;
  show2MonthsPromotion?: boolean;
  netFirstPaymentAmount: number;
  netFirstPaymentAmountAfterPromotionalPeriod?: number;
  periodOfCover: number;
  discountPaymentType?: 'cc' | 'ach';
  brand: string;
  alignment?: 'left' | 'center' | 'right';
  displayIcon?: 'none' | 'show';
};

const styles = {
  offerPanel: 'flex flex-col w-full gap-space-100',
  group: 'flex flex-col gap-space-200',
  pill: 'flex flex-row items-center gap-space-200 py-0.5 pl-space-400 pr-space-300 rounded-radius-200 border border-success-200 bg-success-100 text-text-success text-body-small-strong',
};

const alignmentClasses = {
  left: 'text-left items-start',
  center: 'text-center items-center',
  right: 'text-right items-end',
};

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const OfferPanelA = ({
  periodOfCover,
  discountPercentage,
  discountTerm,
  show2MonthsPromotion,
  netFirstPaymentAmount,
  netFirstPaymentAmountAfterPromotionalPeriod,
  discountPaymentType,
  brand,
  alignment,
  displayIcon = 'show',
}: OfferPanelProps) => {
  const formatPillText = () => {
    const achMarker = discountPaymentType === 'ach' ? '*' : '';

    if (show2MonthsPromotion) {
      return "Our Lowest Price Ever is Back - Don't Miss Out!";
    }

    if (discountPercentage && discountTerm === periodOfCover) {
      return `${discountPercentage}% off${achMarker}`;
    }

    if (discountPercentage && discountTerm && discountTerm < periodOfCover) {
      return `${discountPercentage}% off for first ${discountTerm} months${achMarker}`;
    }

    return 'ONLINE OFFER';
  };

  const innerAlignment = alignment
    ? alignmentClasses[alignment]
    : 'text-center items-center tablet:text-right tablet:items-end';

  return (
    <div className={`${styles.offerPanel} ${innerAlignment}`} data-testid="offer-panel">
      <div className={`${styles.group} ${innerAlignment}`}>
        <span className={styles.pill}>
          {formatPillText()}
          {displayIcon === 'show' && <GiftIcon size={12} color="currentColor" />}
        </span>
        <p className="text-body-strong text-text-body">Add {brand} Appliance Care:</p>
        <p className="text-body-strong text-text-body">
          {!!netFirstPaymentAmountAfterPromotionalPeriod &&
            !show2MonthsPromotion &&
            netFirstPaymentAmount < netFirstPaymentAmountAfterPromotionalPeriod && (
              <span className="line-through text-text-placeholder mr-1">
                {currencyFormatter.format(netFirstPaymentAmountAfterPromotionalPeriod)}
              </span>
            )}
          {currencyFormatter.format(netFirstPaymentAmount)} a month
        </p>
      </div>
      <div className={`${styles.group} ${innerAlignment}`}>
        <p className="text-body-large-strong text-text-success">
          Flexible monthly plan,
          <br />
          cancel anytime.
        </p>
        <p className="text-body-small text-text-body tablet:max-w-77.75">
          Applicable taxes calculated during checkout.
          {discountPaymentType === 'ach' && !show2MonthsPromotion && (
            <>
              <br />
              *Discount applies to payments made via Bank Account only.
            </>
          )}
        </p>
      </div>
    </div>
  );
};
